let interactionDisabled = false;
let preventDocumentEventTypes = [
  'mousedown', 'mouseup', 'keydown', 'keypress', 'keyup'
];
let preventInteractionElement;

function preventEvent(event) {
  event.preventDefault();
  event.stopPropagation();

  if (event.stopImmediatePropagation) {
    event.stopImmediatePropagation();
  }
}

function blurActiveElement() {
  let activeElement = document.activeElement;
  if (activeElement) {
    activeElement.blur();
  }
}

function insertPreventInteractionNode() {
  let element = document.createElement('div');
  element.id = 'c5-core-block-input';

  document.body.appendChild(element);

  preventInteractionElement = element;
}

function setWindowInteractionDisabled(disable) {
  if (!interactionDisabled && disable) {
    if (!preventInteractionElement) {
      insertPreventInteractionNode();
    }

    for (let i in preventDocumentEventTypes) {
      document.addEventListener(preventDocumentEventTypes[i], preventEvent);
    }
    preventInteractionElement.style.display = 'block';
    blurActiveElement();
  } else if (interactionDisabled && !disable) {
    for (let i in preventDocumentEventTypes) {
      document.removeEventListener(preventDocumentEventTypes[i], preventEvent);
    }
    preventInteractionElement.style.display = 'none';
  }

  interactionDisabled = !!disable;
}

export default setWindowInteractionDisabled;
